import { Component, OnInit } from '@angular/core';
import { DisplayComponents, DisplayService } from 'src/app/app.component.service';

@Component({
  selector: 'app-noaccess',
  templateUrl: './noaccess.component.html',
  styleUrls: ['./noaccess.component.css']
})
export class NoaccessComponent implements OnInit {

  constructor(private displayService: DisplayService) { }

  ngOnInit(): void {
    Promise.resolve().then(()=>{
      this.displayService.setDisplay(
        new DisplayComponents
        (
          false,
          false,
          false,
          false,
          false
        )
      );
    });
  }

}
